export default __webpack_public_path__ + "static/media/ebooks_covers.3d260a28.png";